module.exports = __webpack_public_path__ + "img/359.7e76ec72.jpg";